import saveAs from 'file-saver';

const UTF8_BOM = new Uint8Array([0xef, 0xbb, 0xbf]);

export default function saveCsv(content, fileName) {
  const blob = new Blob([UTF8_BOM, content], { type: 'text/csv;charset=utf-8' });
  saveAs(blob, fileName);
}
